import englishMessages from 'ra-language-english';

export default {
    ...englishMessages,
    auth: {
        sign_in_required: 'Please sign in to upload files',
    },
    resources: {
        cases: {
            name: 'Case |||| Cases',
            fields: {
                documents: 'Documents',
                document_title_placeholder: 'Enter document title'
            },
            no_documents: 'No documents available',
            notifications: {
                document_deleted: 'Document deleted successfully',
                document_removed_from_list: 'Document removed from list (file was already deleted)',
                error_deleting_document: 'Error deleting document',
                error_updating_list: 'Error updating document list',
                download_started: 'Download started...',
                file_not_found: 'File not found',
                error_downloading: 'Error downloading file',
                title_updated: 'Document title updated successfully',
                error_updating_title: 'Error updating document title',
                no_messages_to_delete: 'No messages to delete.',
                all_messages_deleted: 'All messages deleted.',
                failed_to_delete_messages: 'Failed to delete messages.'
            },
            confirmations: {
                remove_missing_file: 'This file no longer exists in storage. Would you like to remove it from the list?',
            },
            actions: {
                download: 'Download',
                delete: 'Delete',
            },
            dialogs: {
                edit_title: 'Edit Document Title'
            },
        },
        cofidisCases: {
            name: 'Bank Case |||| Bank Cases',
            fields: {
                caseNumber: 'Case Number',
                primerTitular: 'First Holder',
                segundoTitular: 'Second Holder',
                gastosVivienda: 'Housing Expenses',
                otrosDatos: 'Other Data',
                status: 'Status',
                registeredDate: 'Registration Date',
                note: 'Notes',
            },
            actions: {
                create: 'New Bank Case',
            },
        },
        formSimpleLeads: {
            name: 'Form Simple |||| Form Simple',
            fields: {
                primerTitular: 'First Holder',
                segundoTitular: 'Second Holder',
                telefono: 'Phone',
                registeredDate: 'Registration Date',
                operacionesAgent: 'Operaciones',
                comercialAgent: 'Comercial',
            },
        },
    },
};